'use client'

import { useState, useEffect } from 'react'
import Image from 'next/image'
import Modal from 'react-modal'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/classic/light'

const MovieModal = ({ src, thumbnail, title }) => {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        Modal.setAppElement('#hivenext')
    }, [])

    const closeModal = () => {
        setIsOpen(false)
    }

    return (
        <>
            <button
                type="button"
                onClick={() => setIsOpen(true)}
                className="block w-full cursor-pointer transition-opacity hover:opacity-80"
                aria-label={`Play video: ${title}`}
            >
                <Image
                    src={thumbnail}
                    alt={title}
                    width={400}
                    height={225}
                    className="w-full h-auto"
                />
            </button>

            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                contentLabel={title}
                overlayClassName="z-[1055] fixed outline-0 top-0 bottom-0 left-0 right-0 bg-modal-overlay"
                className="fixed top-1/2 left-1/2 right-auto bottom-auto -mr-[50%] -translate-y-1/2 -translate-x-1/2 w-[calc(100%-60px)] max-w-4xl max-h-[calc(100vh-60px)] rounded-sm shadow-2xl outline-none"
                bodyOpenClassName="ReactModal__Body--open"
                htmlOpenClassName="ReactModal__Html--open"
            >
                <button
                    type="button"
                    onClick={closeModal}
                    className="absolute -top-3 -right-3 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow-lg text-dark hover:text-primary transition-colors z-10"
                    aria-label="Close video"
                >
                    <FontAwesomeIcon icon={faXmark} className="text-lg" />
                </button>

                <div className="relative pb-[56.25%] h-0 bg-black rounded-lg overflow-hidden">
                    <iframe
                        src={src}
                        className="absolute top-0 left-0 w-full h-full"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        title={title}
                    />
                </div>
            </Modal>
        </>
    )
}

export default MovieModal
